<script>
import Store from 'stores/overview/catalogue/store';
import OverviewNav from './../overview/OverviewNav.vue';
import BackListing from './../overview/BackListing.vue';
import AnnotationsTab from 'vcomponents/pages/overview/AnnotationsTab.vue';
import KpiList from 'vcomponents/utilities/KpiList.vue';

export default {
    components: {
        OverviewNav,
        BackListing,
        AnnotationsTab,
        KpiList,
    },
    props: {
        type: {
            type: String,
            required: true,
        },
        itemid: {
            type: Number,
            required: true,
        },
        declid: {
            type: Number,
            default: null,
        },
        declinable: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        identity() {
            return {
                type: this.type,
                // Catalog "id" field is special (contains itemid, declid and sometimes useDeclination legacy bool)
                id:
                    this.itemid +
                    '_' +
                    (this.declid ? this.declid : '0') +
                    (this.declinable ? '_Y' : ''),
            };
        },
        splitter() {
            return new RegExp('\\?_f=catalogueitem&id=(\\d+)(?:&declid=(\\d+))?');
        },
    },
    created() {
        this.$store.registerModule('catalogOverview', Store);
    },
};
</script>
